'use strict';

/**
 * This component displays all the activities in a specific tag.
 * This expects that you give the tag short name as an attr
 */
(function () {
  'use strict';

  angular.module('vnext').directive('msTaggedActivities', msTaggedActivities).constant('tagFilters', [[{
    tag: 'type:video',
    label: 'Video'
  }, {
    tag: 'type:article_long',
    label: 'Long Article'
  }, {
    tag: 'type:article_short',
    label: 'Short Article'
  }, {
    tag: 'type:quiz',
    label: 'Quiz'
  }, {
    tag: 'type:inspiration_image',
    label: 'Inspirational Image'
  }, {
    tag: 'type:audio',
    label: 'Audio'
  }]]);

  msTaggedActivities.$inject = [];

  /* @ngInject */
  function msTaggedActivities() {
    var directive = {
      bindToController: true,
      templateUrl: 'vnext/templates/taggedActivities.html',
      controller: ['NotifyingSvc', 'searchPageSvc', 'tagFilters', 'activityRouter', TaggedActivitiesCtrl],
      controllerAs: 'vm',
      restrict: 'AE',
      scope: {
        channel: '=?',
        pageTag: '=?',
        limit: '=?'
      }
    };
    return directive;
  }

  /* @ngInject */
  function TaggedActivitiesCtrl(NotifyingSvc, searchPageSvc, tagFilters, activityRouter) {
    var vm = this;
    vm.start = start;
    vm.filters = [];
    vm.$onInit = activate;

    function activate() {
      vm.loading = true;
      searchPageSvc.loadChannelActivities(vm.pageTag, vm.channel, 100).then(function (activities) {
        vm.loading = false;
        vm.activities = activities;
        vm.filters = searchPageSvc.filterFilters(tagFilters, activities);
      });
    }

    function start(activity) {
      // we DON'T use the train routing for inspirations
      if (activity.type.name === 'CORE_INSPIRATION' || activity.type.name === 'COMMUNITY_INSPIRATION') {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
          templateUrl: 'vnext/templates/modal-inspiration.html',
          controller: ['close', 'inspiration', function (close, inspiration) {
            this.inspiration = inspiration;
            this.close = close;
          }],
          inputs: {
            inspiration: activity
          }
        });
      } else {
        activityRouter.createTrain(activity);
      }
    }
  }
})();